import { createApiClient } from '@hutdrop/api-client';

export const apiUrl = (import.meta.env.VITE_API_URL ?? '').trim().replace(/\/$/, '');

export const api = createApiClient({ baseUrl: apiUrl, authPath: '/v1/admin/auth' });
